import DotLayout from "components/dot-layout";
import moment from "moment";
import { converPlaceToText } from "utils/common";

interface Props {
	betData: any[];
	gameType: number;
}
function HistoryBetDesktop(props: Props) {
	const { betData, gameType } = props;

	const mapPlaceBet = (betList: { place: number; stake: number }[]) => {
		let betObject: any = {};
		betList.forEach((item) => {
			if (betObject[item.place]) {
				betObject[item.place].stake += item.stake;
			} else {
				betObject = {
					...betObject,
					[item.place]: {
						stake: item.stake,
						place: item.place,
					},
				};
			}
		});
		const betListArr: { stake: number; place: number }[] = [];
		for (const key in betObject) {
			betListArr.push(betObject[key]);
		}

		return betListArr.map((item, index) => (
			<p key={index}>
				<span>{converPlaceToText(item.place, gameType)}:</span> {new Intl.NumberFormat().format(item.stake)}
			</p>
		));
	};
	return (
		<table>
			<thead className="table-header">
				<tr>
					<th>Phiên</th>
					<th>Thời Gian</th>
					<th>Cửa Đặt</th>
					<th>Kết Quả</th>
					<th>Đặt Cược</th>
					<th>Hoàn Trả</th>
					<th>Tiền Thắng</th>
				</tr>
			</thead>
			<tbody>
				{betData.length > 0 ? (
					betData.map((item) => (
						<tr className="table-row" key={item.id}>
							<td>{item.game.session_id}</td>
							<td>{moment(item.created_at).format("DD/MM/yyyy HH:mm:ss")}</td>
							<td className="placedBet">{mapPlaceBet(item.bets)}</td>
							<td>
								{item.game.result && <DotLayout gameType={gameType} dotList={item.game.result} size={16} dotListAdjustment={item.adjustment} />}
								{!item.game.result && item.game.status?.id === 1 && <span style={{ color: "#ff0000" }}>Phiên huỷ</span>}
								{!item.game.result && item.game.status?.id === 0 && <span>Chờ mở thưởng</span>}
							</td>
							<td>{new Intl.NumberFormat().format(item.stake)}</td>
							<td>
								{item.adjustment ? (
									<>
										<div>
											<span className="moneyAdjustment">{new Intl.NumberFormat().format(item.refund)}</span>
										</div>
										<div>
											<span>{new Intl.NumberFormat().format(item.adjustment.refund)}</span>
										</div>
									</>
								) : (
									<div>
										<span>{new Intl.NumberFormat().format(item.refund)}</span>
									</div>
								)}
							</td>
							<td>
								{item.adjustment ? (
									<>
										<div>
											<span className="moneyAdjustment">{new Intl.NumberFormat().format(item.win)}</span>
										</div>
										<div>
											<span style={{ color: item.adjustment.win > 0 ? "#00ff57" : "red" }}>{new Intl.NumberFormat().format(item.adjustment.win)}</span>
										</div>
									</>
								) : (
									<span style={{ color: item.win > 0 ? "#00ff57" : "#fff" }}>{new Intl.NumberFormat().format(item.win)}</span>
								)}
							</td>
						</tr>
					))
				) : (
					<tr className="table-row">
						<td colSpan={7}>
							<p style={{ padding: "16px 0" }}>Không có dữ liệu</p>
						</td>
					</tr>
				)}
			</tbody>
		</table>
	);
}

export default HistoryBetDesktop;
